import { CheckDomainIsTakenErrors } from '../../typing';
import { parseDomain } from '../../utils';
export const checkDomainIsTaken = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const _await$import$Domains = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
      httpClient
    }),
    checkDomainAvailability = _await$import$Domains.checkDomainAvailability,
    getWhoisAvailability = _await$import$Domains.getWhoisAvailability,
    domainsLogger = _await$import$Domains.domainsLogger;
  try {
    const _await$checkDomainAva = await checkDomainAvailability({
        domain: parsedDomain.asciiDomain
      }),
      availability = _await$checkDomainAva.availability;
    return {
      isAvailable: !!(availability != null && availability.available),
      premium: availability == null ? void 0 : availability.premium
    };
  } catch (e) {
    var _e$response, _e$response2, _e$response3;
    // Don't delete this part
    const statusCode = e == null || (_e$response = e.response) == null ? void 0 : _e$response.status;
    const statusApplicationError = (_e$response2 = e.response) == null || (_e$response2 = _e$response2.data) == null || (_e$response2 = _e$response2.details) == null || (_e$response2 = _e$response2.applicationError) == null ? void 0 : _e$response2.code;
    const statusMessage = (_e$response3 = e.response) == null || (_e$response3 = _e$response3.data) == null ? void 0 : _e$response3.message;
    if (statusCode !== 400) {
      throw e;
    }
    if (statusApplicationError === 'DOMAINS_UNSUPPORTED_TLD') {
      try {
        const whoisAvailability = await getWhoisAvailability({
          domainName: parsedDomain.asciiDomain
        });
        if (whoisAvailability.isTaken) {
          return {
            isAvailable: false
          };
        }
        return {
          isAvailable: false,
          error: CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD
        };
      } catch {
        return {
          isAvailable: false,
          error: CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD
        };
      }
    }
    if (statusMessage === 'TLD_NOT_SUPPORTED') {
      return {
        isAvailable: false,
        error: CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD_REGIONAL
      };
    }
    if (statusMessage === 'INVALID_DOMAIN') {
      return {
        isAvailable: false,
        error: CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD
      };
    }
    domainsLogger({
      entity: 'canConnectOrBindRootDomain',
      type: 'error',
      message: 'Error in checkDomainIsTaken',
      error: e,
      metadata: {
        domain: parsedDomain.formattedInput
      }
    });
    return {
      isAvailable: false
    };
  }
};
//# sourceMappingURL=checkDomainIsTaken.js.map